/**
 * La guida al software, e le tre domande che le si fanno.
 *
 * Il contenuto sta in `pages/`, un file per postazione — lo stesso taglio che
 * `@errebi/shared` ha fatto sui contratti. Qui c'è solo la vetrina e le tre
 * funzioni che le due schermate usano.
 */
import { seesScreen } from '@errebi/domain';
import { PAGINE_BANCO } from './pages/bench.js';
import { PAGINE_UFFICIO } from './pages/office.js';
/** Le pagine in ordine di lettura: prima il banco, poi l'ufficio. */
export const GUIDE = [...PAGINE_BANCO, ...PAGINE_UFFICIO];
/**
 * Le pagine che si vedono da una postazione, con quei ruoli.
 *
 * L'asimmetria è voluta e sta tutta in questa riga: il banco vede solo le
 * proprie, l'ufficio vede anche quelle del banco. Chi sta in piedi cerca la sua
 * pagina fra poche; chi sta in ufficio deve poter leggere la stessa pagina che
 * ha davanti la persona al telefono.
 */
export function pagesFor(station, roles) {
    return GUIDE.filter((p) => (station === 'ufficio' || p.station === 'banco') && seesScreen(roles, p.roles));
}
export function pageBy(k) {
    return GUIDE.find((p) => p.k === k);
}
/**
 * The page that tells one screen of a station: what «Come funziona» opens.
 *
 * Only the station's own pages: the office's `/` is the summary, not the
 * bench's home, even if one day the two paths coincide.
 */
export function pageForScreen(station, screen) {
    return GUIDE.find((p) => p.station === station && p.screen === screen);
}
/**
 * I file di figura che una postazione può dover mostrare.
 *
 * Serve al test di ciascuna applicazione: ogni nome che compare qui deve avere
 * un import nel suo `figures.ts`, o la pagina mostra un rettangolo vuoto senza
 * che niente protesti.
 */
export function figureFiles(station) {
    const viste = GUIDE.filter((p) => station === 'ufficio' || p.station === 'banco');
    return viste.flatMap((p) => p.sections.flatMap((s) => (s.figure ? [s.figure.file] : [])));
}
//# sourceMappingURL=index.js.map